// Layout Constants
export const CARD_HEIGHT = 220;
export const MAX_PREVIEW_METRICS = 3;

// Modal Constants
export const MODAL_MAX_WIDTH = 800;
export const MODAL_WIDTH = '90%';
export const MODAL_MAX_HEIGHT = '80%';
export const MODAL_PADDING = 24;
export const PAPER_PADDING = 16;

// Icon Constants
export const ICON_SIZE = 20;
export const ICON_CONTAINER_SIZE = 32;
export const ICON_MARGIN_RIGHT = 8;
export const ICON_CONTAINER_MARGIN_RIGHT = 12;

// Color Constants
export const DEFAULT_METRIC_COLOR = '#FF6B35';
export const COMING_SOON_COLOR = '#9E9E9E';
export const SPEED_ICON_COLOR = '#2196F3';
export const TEXT_COLOR = '#666';

// Typography Constants
export const FONT_SIZE_LARGE = '1.25rem';
export const FONT_SIZE_SMALL = '1rem';

// Spacing Constants
export const MARGIN_TOP = 8;
